import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { select, Store } from '@ngrx/store';

import { has, isNil, isUndefined } from 'lodash-es';
import { map, Observable, of } from 'rxjs';
import { concatMap, filter } from 'rxjs/operators';

import * as fromPropertyProfileSelectors from '../../../../../store/selectors/property-profile.selectors';
import { SchoolView } from '../../../../../typings/profile';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-profile-school-detail-view',
  standalone: false,
  templateUrl: './view.page.html'
})
export class SchoolDetailViewPageComponent {
  private activatedRoute = inject(ActivatedRoute);
  private store = inject(Store);

  profileId: string | null;
  schoolNumber: string | null;
  school$: Observable<SchoolView>;

  defaultHref: string;

  constructor() {
    this.profileId = this.activatedRoute.snapshot.paramMap.get('id');
    this.schoolNumber = this.activatedRoute.snapshot.paramMap.get('schoolNumber') ?? '';

    const defaultBackHref: string | undefined = this.activatedRoute.snapshot.data['defaultBackHref'];
    this.defaultHref = [defaultBackHref ?? '', 'profile', this.profileId, 'schools'].join('/');

    this.school$ = of(this.profileId).pipe(
      filter((id) => !isNil(id)),
      concatMap((id) =>
        this.store.pipe(
          select(fromPropertyProfileSelectors.selectPropertyProfileSchoolByIndex(id, Number(this.schoolNumber) - 1))
        )
      ),
      filter((school) => !isUndefined(school)),
      map((school) => ({
        ...school,
        isPrivateSchool: has(school, 'Affiliation')
      }))
    );
  }
}
